import React, { Component } from "react";
import {
  Table,
  Input,
  Button,
  Card,
  message,
  Tag,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { connect } from "react-redux";
import { getDateYYYYMM } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import {
  req_list_pim_cases_staff,
  req_add_pim_staff_review,
  req_add_pim_staff_backfill,
  req_add_pim_staff_overtime,
  req_add_pim_staff_swap,
  req_add_pim_staff_flexible,
} from "../../api";
import DisagreeCaseModal from "./disagree-case-modal";
import { API_BASE } from "../../utils/contrains";
import ReviewHistoryLogModal from "./review-history-log-modal";
import DayBunchLogModal from "./day-bunch-log-modal";

class AllApplyCasesReview extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    ip: "0.0.0.0",
    insideIPCheck: false,
    insertRow: {
      Uid: "",
      StaffCode: "",
    },
    item: {},
    isShowBackFillModal: false,
    isShowOverTimeModal: false,
    isShowDisagreeModal: false,
    isShowDayBunchLogModal: false,
    isShowReviewHistoryLogModal: false,
    searchField: "None",
    searchValue: "",
    selectedRowKeys: [],
    selectedRows: [],
    antiShake: false, // 防止重複點擊
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_item_list();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { nowYearMonth, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_cases_staff(
      userLevel,
      userCode,
      nowYearMonth,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false, antiShake: false });
      // console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        antiShake: false,
        loading: false,
      });
    }
  };

  api_add_item_backfill = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_backfill(item, token);
    return result.status;
  };

  api_add_item_swap = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_swap(item, token);
    return result.status;
  };

  api_add_item_overtime = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_overtime(item, token);
    return result.status;
  };

  api_add_item_flexible = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_flexible(item, token);
    return result.status;
  };

  api_add_item_review = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_review(item, token);
    return result.status;
  };

  // 樣式設定 //////////////////////////////////////////////

  style_switch_color_tag(column, param) {
    switch (column) {
      case "REASON":
        switch (param) {
          case "工作日":
            return "blue";
          case "休息日":
            return "green";
          case "例假日":
          case "國定假日":
          case "停班停課":
            return "red";
          case "休假日":
            return "gold";
          case "平假日調換":
            return "purple";
          case "工作日調移":
            return "Tan";
          default:
            return "default";
        }
      case "WEEK":
        switch (param) {
          case "週一":
          case "週二":
          case "週三":
          case "週四":
          case "週五":
            return "blue";
          case "週六":
            return "green";
          case "週日":
            return "red";
          default:
            return "default";
        }
      case "STATUS_WORK":
        switch (param) {
          case "PASS":
            return "red";
          case "WORK":
            return "blue";
          default:
            return "blue";
        }
      case "TYPE_APPLY":
        switch (param) {
          case "補簽到退申請":
            return "blue";
          case "工作日加班申請":
            return "orange";
          case "休息日加班申請":
            return "red";
          case "平假日調換申請":
            return "purple";
          case "工作日調移申請":
            return "Tan";
          case "單日作息調整申請":
            return "#34495e";
          default:
            return "default";
        }
      case "STATUS_CONFIRM":
        switch (param) {
          case "NO":
            return "red";
          case "YES":
            return "green";
          default:
            return "default";
        }
      default:
        return "blue";
    }
  }

  next_applyStatus = (ReviewFinishLevel, ApplyStatus, Status) => {
    switch (ReviewFinishLevel) {
      case "ABC":
        switch (ApplyStatus) {
          case "APPLY": //二級單位主管審查
            return Status === "Y" ? "AY" : "AN";
          case "AY": //一級單位主管審查
            return Status === "Y" ? "BY" : "BN";
          case "BY": // 人事室承辦人審查
            return Status === "Y" ? "ALLAGREE" : "CN";
          default:
            return "NO";
        }
      case "XBC":
        switch (ApplyStatus) {
          case "APPLY": //一級單位主管審查
            return Status === "Y" ? "BY" : "BN";
          case "BY": // 人事室承辦人審查
            return Status === "Y" ? "ALLAGREE" : "CN";
          default:
            return "NO";
        }
      case "ABCDE":
        switch (ApplyStatus) {
          case "APPLY": //二級單位主管審查
            return Status === "Y" ? "AY" : "AN";
          case "AY": //一級單位主管審查
            return Status === "Y" ? "BY" : "BN";
          case "BY": // 人事室承辦人審查
            return Status === "Y" ? "CY" : "CN";
          case "CY": // 人事室承辦主管審查
            return Status === "Y" ? "DY" : "DN";
          case "DY": // 人事室主任審查
            return Status === "Y" ? "ALLAGREE" : "EN";
          default:
            return "NO";
        }
      case "XBCDE":
        switch (ApplyStatus) {
          case "APPLY": //一級單位主管審查
            return Status === "Y" ? "BY" : "BN";
          case "BY": // 人事室承辦人審查
            return Status === "Y" ? "CY" : "CN";
          case "CY": // 人事室承辦主管審查
            return Status === "Y" ? "DY" : "DN";
          case "DY": // 人事室主任審查
            return Status === "Y" ? "ALLAGREE" : "EN";
          default:
            return "NO";
        }
      default:
        return "NO";
    }
  };

  next_statusApplyDescription = (Status) => {
    switch (Status) {
      case "APPLY":
        return "申請中";
      case "AY":
        return "單位二級主管通過";
      case "BY":
        return "單位一級主管通過";
      case "CY":
        return "人事室承辦人通過";
      case "DY":
        return "人事室承辦主管通過";
      case "EY":
        return "人事室主任通過";
      case "ALLAGREE":
        return "申請已通過";
      case "AN":
        return "單位二級主管未通過";
      case "BN":
        return "單位一級主管未通過";
      case "CN":
        return "人事室承辦人未通過";
      case "DN":
        return "人事室承辦主管未通過";
      case "EN":
        return "人事室主任未通過";
      case "ZN":
        return "註銷";
      default:
        return "申請未通過";
    }
  };
  // 操作互動處理 //////////////////////////////////////////////
  handle_btn_ok = () => {
    const { selectedRows } = this.state;
    //console.log(selectedRows);
    if (selectedRows.length > 0) {
      try {
        selectedRows.forEach((row) => {
          this.handle_ok_process(row);
        });
      } catch (e) {
      } finally {
        message.success("已完成處理");
        this.setState({ data: [] }, () => {
          this.api_item_list();
        });
      }
    } else {
      message.error("請選擇一筆資料!");
    }
  };

  handle_ok_process = (row) => {
    const { userCode } = this.props.user;
    const {
      Id,
      Uid,
      StaffCode,
      ApplyType,
      ReviewFinishLevel,
      ApplyStatus,
      ApplyDate,
    } = row;
    const status = this.next_applyStatus(ReviewFinishLevel, ApplyStatus, "Y");
    try {
      switch (ApplyType) {
        case "補簽到退申請":
          const item_backfill = {
            ApplyType: ApplyType,
            Id: Id,
            Uid: Uid,
            BunchDate: ApplyDate,
            BunchCaseId: Id,
            StaffCode: StaffCode,
            BackFillStatus: status,
            ApplyStatus: status,
            OperatorCode: userCode,
            OperatorDescription: this.next_statusApplyDescription(status),
          };
          //console.log(item_backfill);
          this.api_add_item_backfill(item_backfill);
          break;
        case "工作日加班申請":
          const item_overtime_d = {
            ApplyType: ApplyType,
            Id: Id,
            Uid: Uid,
            StaffCode: StaffCode,
            OvertimeDate: ApplyDate,
            OvertimeCaseId: Id,
            OvertimeStatus: status,
            ApplyStatus: status,
            OperatorCode: userCode,
            OperatorDescription: this.next_statusApplyDescription(status),
          };
          //console.log(overtime_overtime);
          this.api_add_item_overtime(item_overtime_d);
          break;
        case "休息日加班申請":
          const item_overtime_w = {
            ApplyType: ApplyType,
            Id: Id,
            Uid: Uid,
            StaffCode: StaffCode,
            OvertimeDate: ApplyDate,
            OvertimeCaseId: Id,
            OvertimeStatus: status,
            ApplyStatus: status,
            OperatorCode: userCode,
            OperatorDescription: this.next_statusApplyDescription(status),
          };
          //console.log(overtime_overtime);
          this.api_add_item_overtime(item_overtime_w);
          break;
        case "平假日調換申請": 
        case "工作日調移申請":
          const datePart = ApplyDate.split("<=>")[1];
          const date = datePart.replace(/週.*$/, "").trim();

          const item_swap = {
            ApplyType: ApplyType,
            Id: Id,
            Uid: Uid,
            StaffCode: StaffCode,
            ApplyStatus: status,
            SwapDate: date,
            SwapCaseUid: Uid,
            SwapStatus: status,
            OperatorCode: userCode,
            OperatorDescription: this.next_statusApplyDescription(status),
          };
          this.api_add_item_swap(item_swap);
          break;
        case "單日作息調整申請":
          const item_flexible_a = {
            ApplyType: ApplyType,
            Id: Id,
            Uid: Uid,
            StaffCode: StaffCode,
            FlexibleDate: ApplyDate,
            FlexibleCaseId: Id,
            FlexibleStatus: status,
            ApplyStatus: status,
            OperatorCode: userCode,
            OperatorDescription: this.next_statusApplyDescription(status),
          };
          this.api_add_item_flexible(item_flexible_a);
          break;
        default:
          break;
      }
    } catch (e) {
    } finally {
      message.success("已完成處理");
      this.setState({ data: [], antiShake: false }, () => {
        this.api_item_list();
      });
    }
  };

  handle_btn_event = (type, item) => {
    console.log(item);
    switch (type) {
      case "disagree":
        this.setState({ isShowDisagreeModal: true, item });
        break;
      case "agree":
        if (this.state.antiShake) return;
        this.setState({ antiShake: true });
        this.handle_ok_process(item);
        break;
      case "bunch_log":
        this.setState({ isShowDayBunchLogModal: true, item });
        break;
      case "review_history_log":
        const { ApplyType, Id, Uid } = item;
        const row = {
          ReviewType: "",
          CaseKey: "",
        };
        item = row;
        switch (ApplyType) {
          case "補簽到退申請":
            row.ReviewType = "BACKFILL";
            row.CaseKey = Id;
            this.setState({ isShowReviewHistoryLogModal: true, item });
            break;
          case "工作日加班申請":
            row.ReviewType = "OVERTIME";
            row.CaseKey = Id;
            this.setState({ isShowReviewHistoryLogModal: true, item });
            break;
          case "休息日加班申請":
            row.ReviewType = "OVERTIME";
            row.CaseKey = Id;
            this.setState({ isShowReviewHistoryLogModal: true, item });
            break;
          case "平假日調換申請":
            row.ReviewType = "SWAP";
            row.CaseKey = Uid;
            this.setState({ isShowReviewHistoryLogModal: true, item });
            break;
          case "單日作息調整申請":
            row.ReviewType = "FLEXIBLE";
            row.CaseKey = Id;
            this.setState({ isShowReviewHistoryLogModal: true, item });
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  };

  handle_data_refresh = () => {
    this.api_item_list();
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    const { antiShake } = this.state;
    this.columns = [
      {
        title: "操作",
        width: "80px",
        fixed: "true",
        align: "center",
        render: (item) => (
          <>
            <button
              className="btn btn-success btn-sm"
              style={{ width: "80px" }}
              disabled={antiShake}
              onClick={() => this.handle_btn_event("agree", item)}
            >
              <i className="fas fa-clipboard-check"></i>
              <span style={{ marginLeft: "4px" }}>同&emsp;意</span>
            </button>
            <button
              className="btn btn-danger btn-sm"
              style={{ width: "80px" }}
              onClick={() => this.handle_btn_event("disagree", item)}
            >
              <i className="fas fa-file-excel"></i>
              <span style={{ marginLeft: "4px" }}>不同意</span>
            </button>
          </>
        ),
      },
      {
        title: "申請分類",
        dataIndex: "ApplyType",
        key: "ApplyType",
        align: "center",
        width: 100,
        filters: [
          {
            text: "工作日加班申請",
            value: "工作日加班申請",
          },
          {
            text: "休息日加班申請",
            value: "休息日加班申請",
          },
          {
            text: "平假日調換申請",
            value: "平假日調換申請",
          },
          {
            text: "工作日調移申請",
            value: "工作日調移申請",
          },
          {
            text: "單日作息調整申請",
            value: "單日作息調整申請",
          },
          {
            text: "補簽到退申請",
            value: "補簽到退申請",
          },
        ],
        // specify the condition of filtering result
        // here is that finding the name started with `value`
        onFilter: (value, record) => record.ApplyType.indexOf(value) === 0,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("TYPE_APPLY", text)}>
              {text}
            </Tag>
          </>
        ),
      },
      {
        title: "職號",
        dataIndex: "StaffCode",
        key: "StaffCode",
        align: "center",
        width: 80,
        responsive: ["md"],
        render: (text) => <>{text}</>,
      },
      {
        title: "姓名",
        dataIndex: "StaffName",
        key: "StaffName",
        align: "center",
        width: 80,
        render: (text) => <>{text}</>,
      },
      {
        title: "案件日期",
        align: "center",
        width: 110,
        render: (item) => (
          <>
            {item.ApplyDate} {item.WeekdayName}
          </>
        ),
      },
      {
        title: "起始時間",
        align: "center",
        width: 70,
        render: (item) => (
          <>
            {item.RecordDescription === "補登簽退申請"
              ? ""
              : item.StartTime}
          </>
        ),
      },
      {
        title: "結束時間",
        align: "center",
        width: 70,
        render: (item) => (
          <>
            {item.RecordDescription === "補登簽到申請"
              ? ""
              : item.EndTime}
          </>
        ),
      },
      {
        title: "申請說明",
        width: 100,
        render: (item) => {
          const url = item.ReasonFileUrl;
          const isPdf = url && url.toLowerCase().endsWith(".pdf");

          const handleClick = (e) => {
            e.preventDefault();
            if (isPdf) {
              window.open(API_BASE + url, "_blank", "noopener,noreferrer");
            }
          };

          return (
            <>
              {url ? (
                isPdf ? (
                  <a
                    href={API_BASE + url}
                    onClick={handleClick}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className="fas fa-file-pdf"
                      style={{ fontSize: 20, color: "#d9534f" }}
                    ></i>
                  </a>
                ) : (
                  <Image
                    width={25}
                    height={25}
                    src={API_BASE + url}
                  />
                )
              ) : null}
              {item.RecordDescription}
            </>
          );
        },
      },
      {
        title: "輔助資訊",
        width: 110,
        render: (item) => (
          <div style={{ textAlign: "center" }}>
            <button
              className="btn btn-outline-dark btn-sm"
              style={{ width: "120px" }}
              onClick={() => this.handle_btn_event("review_history_log", item)}
            >
              <i className="fa fa-bars"></i> 審 查 歷 程
            </button>
            {item.ApplyType === "工作日加班申請" ? (
              <button
                className="btn btn-outline-dark btn-sm"
                style={{ width: "120px" }}
                onClick={() => this.handle_btn_event("bunch_log", item)}
              >
                <i className="fa fa-bars"></i> 簽到退紀錄
              </button>
            ) : (
              ""
            )}
          </div>
        ),
      },
    ];
  };

  ///////////////////////////////////////////////////////////
  render() {
    const {
      data,
      userLevel,
      loading,
      nowYearMonth,
      selectedRowKeys,
      isShowDisagreeModal,
      item,
      isShowDayBunchLogModal,
      isShowReviewHistoryLogModal,
    } = this.state;

    const title = (
      <div>
        <Input
          placeholder="年月"
          style={{ width: 100, margin: "0 5px" }}
          value={nowYearMonth}
          onChange={(event) =>
            this.setState({ nowYearMonth: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>{" "}
        <Tooltip placement="top" title="至少選擇一筆">
          {userLevel === "POFFICEA" ? (
            <Button type="primary" onClick={() => this.handle_btn_ok()}>
              <i className="fas fa-check-double"></i>
              <span style={{ marginLeft: "4px" }}>一鍵同意</span>
            </Button>
          ) : (
            <></>
          )}
        </Tooltip>{" "}
      </div>
    );
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
        // console.log(
        //   `selectedRowKeys: ${selectedRowKeys}`,
        //   "selectedRows: ",
        //   selectedRows
        // );
      },
    };
    const hasSelected = selectedRowKeys.length > 0;

    return (
      <Card>
        {title}
        <span style={{ marginLeft: 8 }}>
          {hasSelected ? `選取 ${selectedRowKeys.length} 案` : ""}
        </span>
        <Table
          bordered
          rowKey="Uid"
          rowSelection={rowSelection}
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowDisagreeModal}
          width={350}
          onOk={() => {
            this.setState({ isShowDisagreeModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowDisagreeModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DisagreeCaseModal data={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowDayBunchLogModal}
          width={350}
          onOk={() => {
            this.setState({ isShowDayBunchLogModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowDayBunchLogModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DayBunchLogModal data={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowReviewHistoryLogModal}
          width={450}
          onOk={() => {
            this.setState({ isShowReviewHistoryLogModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowReviewHistoryLogModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ReviewHistoryLogModal data={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AllApplyCasesReview);
